import React from 'react';
import { Icon } from 'ui';

const EstimatedDuration = ({ estimatedMinutesToComplete }) => (
  <span className="LearnContentCardDuration">
    <Icon className="mr-4 c-gray-light fz-14" name="clock" />
    {estimatedMinutesToComplete} {t('time_units.minutes.abbreviation')}
  </span>
);

export default EstimatedDuration;
